const { Tag } = require("antd")

const TagSinDatos = () => {
    return <Tag>Sin información</Tag>
}

export default TagSinDatos